import React from 'react';
import { checkJsonProp } from "../../Utilities";

const InputAdapter = ({input, meta, props, ...rest}) => (
  <>
    <input
      {...input}
      {...rest}
      className={meta.error && meta.touched ? 'is-invalid ' + rest.className : rest.className}
      autoComplete="off"
      autoCorrect="off"
      autoCapitalize="none"
      spellCheck="off"
      disabled={checkJsonProp(props, 'data.disabled') || checkJsonProp(props, 'disabled') || rest.disabled ? true : null}
      maxLength={checkJsonProp(props, 'data.maxLength')}
    />
    {meta.touched && meta.error}
  </>
);

export {InputAdapter};
